export default [
  {
    id: "FAI",
    name: 'Pendiente',
    detail: 'Pendiente',
    color: 'yellow-100',
    summary: 'Pendiente',
    icon: 'mdi-clock',
    countries: ['CL', 'PE']
  },
  {
    id: "PEN",
    name: 'Pendiente',
    detail: '',
    summary: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock ',
    countries: ['CL', 'PE']
  },
  {
    id: "ROK",
    name: 'Recibido',
    detail: 'Recibido',
    summary: 'Recibido',
    color: 'yellow-100',
    icon: 'mdi-inbox-arrow-down',
    countries: ['CL']
  },
  {
    id: "RNO",
    name: 'No recibido',
    detail: '',
    summary: 'No recibido',
    color: 'yellow-100',
    icon: 'mdi-inbox-remove',
    countries: ['CL']
  },
  {
    id: "APR",
    name: 'Aceptado',
    detail: 'Acepta documento electrónico',
    summary: 'Aceptado',
    color: 'blue-100',
    icon: 'mdi-check',
    countries: ['PE']
  },
  {
    id: "APR",
    name: 'Aceptado',
    detail: 'Aceptado',
    summary: 'Aceptado',
    color: 'blue-100',
    icon: 'mdi-check',
    countries: ['CL']
  },
  {
    id: "OBS",
    name: 'Aceptado con discrepancias',
    detail: 'Aceptado con discrepancias',
    summary: 'Aceptado',
    color: 'yellow-100',
    icon: 'mdi-check',
    countries: ['CL']
  },
  {
    id: "REJ",
    name: 'Rechazado',
    detail: 'Rechazado',
    summary: 'Rechazado',
    color: 'red-100',
    icon: 'mdi-close',
    countries: ['PE']
  },
  {
    id: "REJ",
    name: 'Rechazado',
    detail: 'Rechazado',
    summary: 'Rechazado',
    color: 'red-100',
    icon: 'mdi-close',
    countries: ['CL']
  },
  {
    id: "ERJ",
    name: 'Envío rechazado',
    detail: 'Envío rechazado',
    summary: 'Rechazado',
    color: 'yellow-100',
    icon: 'mdi-close ',
    countries: ['CL']
  }
]